<template>
  <!-- <iframe :src="link" frameborder="0" /> -->
  <a
    :id="GOERS_WIDGET_ANCHOR_ID"
    :href="`https://goersapp.com/${link}`"
    data-background-color="transparent"
  >
    Demo Produk Goers Event (Publik)
  </a>
</template>

<script>
import { computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

const GOERS_WIDGET_ANCHOR_ID = '___GOERS___widget';

const getBaseUrl = (url) => {
  const paths = url.split('/');
  const protocol = paths[0];
  const host = paths[2];
  return `${protocol}//${host}`;
};

export default {
  setup() {
    const route = useRoute();

    const link = computed(() => route.query.link);

    function insertScriptWidget() {
      const scriptWidget = document.createElement('script');
      scriptWidget.setAttribute('src', 'https://cdn.goersapp.com/widget/1.2.1/widget.min.js');
      scriptWidget.setAttribute('integrity', 'sha384-SYWte49En/51CagiEURWoKO+a4U1ZOvF4U5bqEuKX52fp/ikiP8onM2mZ4hxZfKg');
      scriptWidget.setAttribute('crossorigin', 'anonymous');
      const anchorWidget = document.getElementById(GOERS_WIDGET_ANCHOR_ID);
      anchorWidget.insertAdjacentElement('afterend', scriptWidget);
    }
    /** */
    function handleMessage(event) {
      // if (event.origin !== getBaseUrl(link.value)) return; // only handle from iframe src
      // TODO: handle message kalo payment dah selesai
      console.log(event.data);
    }

    onMounted(() => {
      insertScriptWidget();
      window.addEventListener('message', handleMessage);
    });

    onUnmounted(() => {
      window.removeEventListener('message', handleMessage);
    });
    return {
      GOERS_WIDGET_ANCHOR_ID,
      link,
    };
  },
};
</script>
